import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonMapItem } from '../polygon-map-item';

@RegisterElement()
export class GrassIsland extends PolygonMapItem {
    protected sizeInMeters: number = 2;
    public override TypeName: string = "GrassIsland";

    constructor(formGroup: FormGroup) {
        super(formGroup, "GrassIsland");
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
    }

    public override clone(): GrassIsland {
        return new GrassIsland(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            }
        ];
    }

    public override default(): GrassIsland {
        return this;
    }
}
